import { useQuery } from 'react-query';
import { getIntercomConversationByEmail, updateIntercomConversation, getIntercomToken } from '@apis/users';

export const getConversationByEmail = async (email: string) => {
  const res: any = await getIntercomConversationByEmail(email);
  return {
    id: res?.response?.data?.conversations?.[0]?.id,
    datadogSessionUrl: res?.response?.data?.conversations?.[0]?.custom_attributes?.datadog_session_url,
  };
};

export const updateConversation = async (conversationId: string, datadogSessionUrl: string) => {
  const res = await updateIntercomConversation(conversationId, {
    custom_attributes: {
      datadog_session_url: datadogSessionUrl,
    },
  });
  return res;
};

export const useGetIntercomToken = (userId, enabled: boolean) => {
  const response = useQuery(
    ['intercomToken', userId],
    async () => {
      const res = (await getIntercomToken()) as unknown as {
        response: { data: { token: string | null } };
      };
      return res?.response?.data || { token: null };
    },
    {
      enabled: enabled && !!userId,
      placeholderData: { token: null },
      useErrorBoundary: false,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      retry: 3,
      staleTime: 1000 * 60 * 60 * 24,
      onError: (error: any) => {
        console.error(error.message);
      },
    },
  );

  return response;
};
